import { derive } from 'store-utils';
import { createStore } from 'store-utils';
import { MaintenanceInfo } from '../maintenance-types';
import { getDismissalFromStorage } from '../utils/local-storage-utils';
import { shouldBlockApp, shouldShowBanner } from '../utils/maintenance-utils';

const baseStore = createStore<MaintenanceStoreState>(
  {
    info: undefined,
    bannerDismissed: getDismissalFromStorage(),
  },
  'MaintenanceStore',
);

const MaintenanceStore = derive(
  {
    bannerOpen: get => {
      const { info } = get(baseStore);
      return info ? shouldShowBanner(info) : false;
    },
    appBlocked: get => {
      const { info } = get(baseStore);
      return info ? shouldBlockApp(info) : false;
    },
  },
  { proxy: baseStore },
);

interface MaintenanceStoreState {
  bannerDismissed: boolean;
  info?: MaintenanceInfo;
}

export default MaintenanceStore;
